import React from "react";
import { Loader } from "lucide-react";

const PageLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <Loader className="animate-spin " color="primary" size={48} />
    </div>
  );
};

export default PageLoader;
